$(function () {
	const $input   = $('[data-search-input]').first();
	const $results = $('[data-search-results]');
	if (!$input.length) return;

	const base       = $('body').attr('data-home') || '/';
	const searchPath = $('[data-search-container]').first().data('search-url') || 'help-center/search';
	const isMobile   = function () { return window.innerWidth <= 768; };
	let timer     = null;
	let blurTimer = null;

	function searchUrl(q) {
		return base + searchPath + '?q=' + encodeURIComponent(q);
	}

	function doSearch(q) {
		if (!$results.length) return;
		clearTimeout(blurTimer);
		$.get(base + searchPath, { q: q }, function (html) {
			$results.html(html);
		});
	}

	function clearResults() {
		if ($results.length) $results.empty();
	}

	function dismiss() {
		clearTimeout(timer);
		clearTimeout(blurTimer);
		$input.val('');
		clearResults();
		$input[0].blur();
		$('#searchOverlay').trigger('click');
	}

	// Desktop: AJAX-пошук при фокусі якщо є текст
	$input.on('focus', function () {
		if (isMobile()) return;
		const q = $(this).val().trim();
		if (q.length >= 2) doSearch(q);
	});

	// Desktop: AJAX з debounce при вводі
	$input.on('input', function () {
		if (isMobile()) return;
		const q = $(this).val().trim();
		clearTimeout(timer);
		if (q.length < 2) { clearResults(); return; }
		timer = setTimeout(function () { doSearch(q); }, 400);
	});

	// Desktop: очищення результатів при blur
	$input.on('blur', function () {
		if (isMobile()) return;
		blurTimer = setTimeout(clearResults, 200);
	});

	// Enter / ESC в інпуті
	$input.on('keydown', function (e) {
		if (e.key === 'Escape') { dismiss(); return; }
		if (e.key !== 'Enter') return;
		const q = $(this).val().trim();
		if (!q) return;
		window.location.href = searchUrl(q);
	});

	// Кнопка "Пошук" — на мобілі редірект, на десктопі теж (enter-поведінка)
	$(document).on('click', '[data-search-container] .btn-primary', function () {
		const q = $input.val().trim();
		if (!q) return;
		window.location.href = searchUrl(q);
	});

	// Теги — на мобілі редірект, на десктопі підставляємо і шукаємо
	$(document).on('click', '.help__searchTags-tags span, .faq__searchTags-tags span', function () {
		const q = $(this).text().trim();
		if (isMobile()) {
			window.location.href = searchUrl(q);
			return;
		}
		clearTimeout(blurTimer);
		$input.val(q).trigger('focus');
		doSearch(q);
	});

	// Хрестик — очистити і прибрати фокус
	$(document).on('click', '.onsearch', function () {
		dismiss();
	});

});
